var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconShareLight = function SvgIconShareLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.675 17.05L22.8 10.26a.932.932 0 00-1.55.812v3.578C14.975 14.728 10 16.165 10 22.96a9.529 9.529 0 003.255 6.882.718.718 0 001.1-.832c-1.771-6.474.84-8.192 6.9-8.292v3.925a.932.932 0 001.55.81l6.875-6.785a1.175 1.175 0 00-.005-1.618v0z",
    stroke: "#000",
    strokeWidth: 1.5
  })));
};
export default SvgIconShareLight;